<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            help-text="The name of the page."
            :error="(errors.name || [])[0]"
        />

        <TextFormGroup
            v-model="data.meta_title"
            name="meta_title"
            label="Meta Title"
            help-text="The meta title of the page."
            :error="(errors.meta_title || [])[0]"
        />

        <TextFormGroup
            v-model="data.meta_description"
            name="meta_description"
            label="Meta Description"
            help-text="The meta description of the page."
            :error="(errors.meta_description || [])[0]"
        />

        <TextFormGroup
            v-model="data.path"
            name="path"
            label="Path"
            help-text="The path of the page."
            :error="(errors.path || [])[0]"
        />

        <hr>

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SubmitFormGroup, TextFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {...this.initial}
    }
  }
}
</script>